'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ActionType } from '@diritto/common/app/inapp-event.constant';
import { HeaderNavMenu, WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { FeatureFlagName } from '@diritto/common/system/constants';
import { BalanceGameRitto2025 } from '@/app/(appHeader)/promotions/2025-balance-game-ritto/BalanceGameRitto2025';
import { useInAppState } from 'contexts/InAppProvider';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { ShareButton } from 'ui-components/navigations/HeaderButtons';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { useShare } from 'ui-hooks/useShare';
import { configure } from 'utils/configure';
import { useFeatureFlagConfig } from '@/ui-hooks/useFeatureFlagConfig';
import { TopUp } from '@/app-components/promotions/TopUp';

const promotionTitle = '리토의 밸런스 게임';

interface PromotionPageProps {
  isApp?: boolean;
}

export const PromotionPage = ({ isApp }: PromotionPageProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const thisUrl = `${configure.serviceUrl}${pathname}`;
  const { isActiveFlag, featureFlagConfigs } = useFeatureFlagConfig();
  const isBalanceGameRitto = isActiveFlag(FeatureFlagName.BalanceGameRitto2025);

  useInAppHeader({
    screen: WebViewScreen.EventDetail,
    title: promotionTitle,
    rightMenuList: [HeaderNavMenu.Share],
  });
  useInAppStatusBar(WebViewScreen.EventDetail);

  const { addActionEventListener } = useInAppState();
  const handleShare = useShare();

  useEffect(() => {
    if (featureFlagConfigs && !isBalanceGameRitto) {
      router.back();
    }
  }, [featureFlagConfigs, isBalanceGameRitto, router]);

  useEffect(
    () =>
      addActionEventListener(params => {
        switch (params.type) {
          case ActionType.Share:
            handleShare({ title: promotionTitle, url: thisUrl });
            break;
          default:
            break;
        }
      }),
    [addActionEventListener, handleShare, thisUrl],
  );

  return (
    <MutableHeaderLayout
      title={promotionTitle}
      isApp={isApp}
      rightButtons={[
        <ShareButton
          key="share"
          params={{
            title: promotionTitle,
            url: thisUrl,
          }}
        />,
      ]}>
      <BalanceGameRitto2025 />
      <TopUp />
    </MutableHeaderLayout>
  );
};
